/**
 * @generated SignedSource<<338a21f07ac20c0655987760c98d0b4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "end"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendorId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endts",
        "variableName": "end"
      },
      {
        "kind": "Variable",
        "name": "reselleraccountid",
        "variableName": "resellerId"
      },
      {
        "kind": "Variable",
        "name": "startts",
        "variableName": "start"
      },
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendorId"
      }
    ],
    "concreteType": "InstantPayoutLinesConnection",
    "kind": "LinkedField",
    "name": "getinstantpayoutlines",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InstantPayoutLine",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vendorPayoutId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "programName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "programType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calculationAudit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "autoPayout",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chargeAmountTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payoutAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chargeAmountRangeTotal",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payoutAmountRangeTotal",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PayoutDetailInstantQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PayoutDetailInstantQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "a2e1a68d62644423a84a03d3459dabeb",
    "id": null,
    "metadata": {},
    "name": "PayoutDetailInstantQuery",
    "operationKind": "query",
    "text": "query PayoutDetailInstantQuery(\n  $vendorId: UUID!\n  $resellerId: UUID!\n  $start: Datetime\n  $end: Datetime\n) {\n  getinstantpayoutlines(vendoraccountid: $vendorId, reselleraccountid: $resellerId, startts: $start, endts: $end) {\n    nodes {\n      vendorPayoutId\n      resellerAccountId\n      resellerAccountName\n      customerAccountName\n      customerAccountId\n      programName\n      programType\n      appName\n      status\n      calculationAudit\n      autoPayout\n      chargeAmountTotal\n      payoutAmount\n      approvedTime\n      approvedBy\n      chargeAmountRangeTotal\n      payoutAmountRangeTotal\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1d8182a21bee8be290176f6742c9b26e";

module.exports = node;
